// extracted by mini-css-extract-plugin
module.exports = {"componentHolder":"TaxiRequests_componentHolder__2_HmD"};